var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "b-btn",
        {
          staticClass: "atmo-button atmo-accented",
          attrs: { disabled: !_vm.$store.getters.getCanSign },
          on: {
            click: function ($event) {
              _vm.showModal = true
            },
          },
        },
        [_vm._v("Отказаться от подписания контракта")]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            scrollable: "",
            size: "md",
            title: "Отказ от подписания контракта",
          },
          on: { close: _vm.cancelSignModal },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function () {
                return [_c("button-close-modal")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _vm.purchaseItem.plain.flags.is_customer
            ? _c("form-row-edit-textarea", {
                attrs: {
                  label: "Комментарий",
                  v: _vm.$v.comment,
                  rows: 5,
                  "label-on-top": "",
                },
                model: {
                  value: _vm.comment,
                  callback: function ($$v) {
                    _vm.comment = $$v
                  },
                  expression: "comment",
                },
              })
            : _vm._e(),
          _vm.purchaseItem.plain.flags.is_supplier &&
          _vm.purchaseItem.is_first_contract
            ? [
                _c("h6", { staticClass: "text-danger fw-600" }, [
                  _vm._v(
                    "В случае отказа от заключения контракта с лицевого счёта вашей организации будет списана комиссия в соответствии с Регламентом ИС АТМО."
                  ),
                ]),
              ]
            : _vm.purchaseItem.plain.flags.is_customer
            ? [
                _c("h6", { staticClass: "text-danger fw-600" }, [
                  _vm._v(
                    "В случае отказа от заключения контракта в соответствии с Регламентом ИС АТМО внесение закупки вне ИС на основании этой закупки будет недоступно."
                  ),
                ]),
              ]
            : _vm._e(),
          _c("h6", { staticClass: "text-danger fw-600" }, [
            _vm._v("Обращаем Ваше внимание, что данное действие необратимо."),
          ]),
          _c(
            "div",
            {
              staticClass: "w-100 px-3",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2 atmo-button-inverse atmo-dimmed",
                  attrs: { disabled: _vm.isDataSending },
                  on: { click: _vm.cancelSignModal },
                },
                [_vm._v("Отмена")]
              ),
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "atmo-button atmo-accented",
                      attrs: { disabled: _vm.$v.$invalid },
                      on: { click: _vm.signDecline },
                    },
                    [_vm._v("Отказаться")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }